import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VTooltip from "v-tooltip";
import VueAnalytics from "vue-analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(VueAnalytics, {
  id: "UA-125325491-1",
  router
});

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(VTooltip);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
